import { useLocation, useNavigate } from 'react-router-dom'
import { LazyImage } from '@frontend/design_system'
import filledHeartIcon from 'assets/icons/whiteMaster/whiteMaster_heartFilled_24x24.webp'
import emptyHeartIcon from 'assets/icons/whiteMaster/whiteMaster_heart_24x24.webp'
import styles from './styles.module.scss'
import { URLS } from 'constants/urls'

export const Favorites = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const isActive = location.pathname.includes(URLS.FAVORITES)
  return (
    <div
      className={styles['button-wrapper']}
      onClick={() => navigate(URLS.FAVORITES)}
    >
      <LazyImage
        width={24}
        height={24}
        key={isActive ? 'filled' : 'empty'}
        src={isActive ? filledHeartIcon : emptyHeartIcon}
      />
    </div>
  )
}
